import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import get from 'lodash/get';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';

const WhitelabelConfigList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Domain',
        path: 'domain',
        sort: true,
        defaultSortOrder: 'ascend',
      },
      {
        label: 'Is new student app',
        path: 'isNewStudentAppEnabled',
        render: (cell) => (cell ? 'Yes' : 'No'),
      },
      {
        label: 'Owner',
        path: 'distributor.name',
        render: (cell, row) => get(row.distributor, 'name', get(row.company, 'name', 'No Owner')),
      },
      {
        label: 'Enabled web apps',
        path: 'cloudfrontDistributions',
        render: (cell) =>
          (cell || [])
            .filter((app) => app.status === 'DEPLOYED')
            .map((app) => app.app)
            .join(', '),
      },
      {
        label: 'Enabled mobile apps',
        path: 'appDistributions',
        render: (cell) =>
          (cell || [])
            .filter((app) => app.iosIconUrl && app.androidIconUrl)
            .map((app) => `${app.app} ${app.buildVersion ? `(${app.buildVersion} - ${app.buildNumber})` : ''}`)
            .join(', '),
      },
      {
        label: 'Actions',
        path: 'action',
        width: '105px',
        render: (cell, row) => {
          return (
            <div>
              <Button icon="delete" onClick={() => props.onDelete(row)} />{' '}
              <Button icon="edit" onClick={() => browserHistory.push(`/whitelabel-configs/${row.id}`)} />
            </div>
          );
        },
      },
    ]}
    rows={props.configs}
  />
);

WhitelabelConfigList.propTypes = {
  configs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      domain: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default WhitelabelConfigList;
